<style lang="scss" src='./AlertDetails.scss' scoped></style>
<template src="./AlertDetails.html"></template>

<script>
import { mapMutations, mapState } from "vuex";
import { getSensorRingGraph } from '@/api/index';
import AlertChart from "@/views/alerts/components/alertList/alertChart/AlertChart.vue";
import GwRing from "@/components/gwRing/GwRing.vue";
import TaskDetails from '@/views/task/details/TaskDetails.vue';

export default {
  name: "AlertDetails",
  props: {
    alert: {
      requierd: true,
    },
    sensor: {
      requiered: false,
    },
    station:{
      requierd: false,
    },
    getRingsDataFromStore: {
      requiered: true,
    },
    showBack: {
      requiered: true,
    }
  },
  data() {
    return {
      ringsData: null,
      loading: {
        ringsData: false
      }
    };
  },
  components: {
    AlertChart,
    GwRing,
    TaskDetails,
  },
  

  watch: {
    alert: function (newAlert, oldAlert) {
      if (newAlert && oldAlert && newAlert.alert_id !== oldAlert.alert_id) {
        this.loadData();
      }
    },
  },


  computed: {
    ...mapState(['course']),

    ...mapState('sensors', {
        showAlertList: (state) => state.showAlertList,
        ringsDataSensorStore: (state) => state.ringsData,
      }),
      isCourseType(){
        if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
          || !this.course.facility_type){
            return true;
        }else{
          return false;
          }
      }
  },

  methods: {
    showAlertDetails() {
      this.setShowAlertList(true);
    },

    getThresholdViolation(alert) {
      
      let alertType = this.consts.AlertType[alert.alert_type_id];
      let reading = null;

      if (alert.sensor) {

        let alertKey = alertType.key;
        if(alert.is_night_time && alert.alert_type_id == 'GROUND_TEMPERATURE'){
          alertKey = 'night_temp'
        }

        const minMax = alert.violation === "READING_HIGH" ? "max_" : "min_";
        reading = alert.sensor.threshold[minMax + alertKey];
      } else if (alert.station && alert.alert_type_id != "WS_COMMUNICATION_FAILURE") {
        const threshold = alert.station.thresholds.find(t => t.alert_type_id === alert.alert_type_id);
        reading = alert.violation === 'READING_HIGH' ? threshold.max : threshold.min;
      }
      
      return this.G_getMeasurement({
        val: reading,
        uom: alert.alert_type.uom,
        addUnit: true,
        invertUOM: false,
      });
    },

    async loadSensorRingGraph() {
      this.loading.ringsData = true;
      const ringsDataReponse = await getSensorRingGraph(this.sensor.sensor_id);
      if (ringsDataReponse) {
        const ringsDataAux = this.G_getSensorRingsData(ringsDataReponse.data);
        if(this.consts.AlertType[this.alert.alert_type_id].key == this.consts.AlertType['SENSOR_TRANSITION'].key){
          this.ringsData =  ringsDataAux[this.consts.AlertType['MOISTURE'].key];
        }else{
          this.ringsData =  ringsDataAux[this.consts.AlertType[this.alert.alert_type_id].key];
        }
      } else {
        this.ringsData = {};
      }
      this.loading.ringsData = false;
    },

    loadData() {
      if (this.getRingsDataFromStore) {
        this.ringsData =  this.ringsDataSensorStore[this.consts.AlertType[this.alert.alert_type_id].key];
      } else {
        this.ringsData = {};
        if (this.alert.station && this.alert.alert_type_id != 'WS_COMMUNICATION_FAILURE') {
          const threshold = this.alert.station.thresholds.find(t => t.alert_type_id === this.alert.alert_type_id);
          const unitOfMeasurament = this.G_getUOM({ uom: threshold.alert_type.uom });
          const current = this.G_getMeasurement({ val: this.alert.reading, uom: threshold.alert_type.uom });
          const maxTh = threshold.max ? this.G_getMeasurement({ val: threshold.max, uom: threshold.alert_type.uom }): null;
          const maxVal = threshold.alert_type.max ? this.G_getMeasurement({ val: threshold.alert_type.max, uom: threshold.alert_type.uom }): null;
          const minTh = threshold.min ? this.G_getMeasurement({ val: threshold.min, uom: threshold.alert_type.uom }): null;
          const minVal = threshold.alert_type.min ? this.G_getMeasurement({ val: threshold.alert_type.min, uom: threshold.alert_type.uom }): null;
          
          this.ringsData = {
            alert: true,
            currentValue: parseFloat(current),
            key: this.alert.alert_type_id,
            maxThreshold: maxTh,
            maxValue: maxVal,
            minThreshold: minTh,
            minValue: minVal,
            unit: unitOfMeasurament
          }
        } else if (this.alert.sensor) {
          this.loadSensorRingGraph();
        }

      }
    },

    ...mapMutations("sensors", ["setShowAlertList"]),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.loadData();
  },
};
</script>
